import { useCallback } from "react";
import ReportService from "../../../../../../../services/reportGeneration";
import { useOpenProgressModal } from "../../../../../../../lib/hooks/useOpenProgressModal";
import { useDownloadText } from "./useDownloadText";

export const usePrintInvestorsReport = (customerId: string) => {
  const { isLoading, setIsLoading, download } = useDownloadText(
    "InvestorsReport.docx",
  );

  const { openModal } = useOpenProgressModal(
    "Generating Investors Summary Report",
    "Generating Investors Summary Report failed",
    (id?: string) => download(id),
    {},
  );

  const print = useCallback(
    async (reportFor: 0 | 1) => {
      try {
        setIsLoading(true);

        const request = {
          customerId,
          reportFor,
        };

        const id: string = await ReportService.generateReportByName(
          "InvestorSummaryReport",
          request,
        );

        openModal(id);
      } catch {
        setIsLoading(false);
      }
    },
    [customerId, openModal, setIsLoading],
  );

  return { isLoading, print };
};
